//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import CreateEditDocument from '../components/createEditDocument.vue';
export default {
  components: {
    CreateEditDocument,
  },
  data() {
    return {
      payload: {
        limit: 10,
        offset: 0,
      },
      // 表格
      loading: false,
      list: [],
      tagGroupList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      // 弹窗
      visible: false,
      editData: {},
      openType: 'create',
      dataset: {},
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'powerElement_agent_create',
        'powerElement_agent_edit',
        'powerElement_agent_delete',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
    datasetId() {
      return this.$route.query.dataset_id;
    },
    isUploadType() {
      return this.dataset?.data_source_type === 'upload';
    },
  },
  async created() {
    this.getList();
    this.getDataset();
  },
  methods: {
    async getDataset() {
      try {
        this.dataset = {};
        const { dataset } = await this.$request({
          url: this.$api.getAgentDataset,
          data: {
            id: this.$route?.query?.dataset_id,
          },
        });
        this.dataset = dataset;
      } catch (err) {
        console.log(err);
        this.dataset = {};
      }
    },
    async getList() {
      this.loading = true;
      this.payload = {
        ...this.payload,
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
      };
      try {
        const { documents, total_count: total } = await this.$request({
          url: this.$api.listAgentDocuments,
          data: {
            dataset_id: this.datasetId,
            ...this.payload,
          },
        });
        this.list = documents;
        this.total = parseInt(total);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    onAdd() {
      this.editData = {};
      this.openType = 'create';
      this.visible = true;
    },
    onEdit(row) {
      this.editData = row;
      this.openType = 'edit';
      this.visible = true;
    },
    async onDelete(row) {
      this.$confirm(`确定移除文档[${row.name}]吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data = {
          id: row.id,
        };
        await this.$request({
          url: this.$api.deleteAgentDocument,
          data,
        });
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.getList();
      });
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    onShowSegment(row) {
      this.$router.push({ name: 'ai-dataset-document-segments', query: { document_id: row.id } });
    },
    goBack() {
      this.$router.history.go(-1);
    },
  },
};
